export const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export const formatExpireTime = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds} giây`;
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  if (remainingSeconds === 0) {
    return `${minutes} phút`;
  }
  return `${minutes} phút ${remainingSeconds} giây`;
};

export const getSecondsRemaining = (timestamp: number | null): number => {
  if (!timestamp) return 0;
  return Math.max(0, Math.floor((timestamp - Date.now()) / 1000));
};
